/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type AssignmentStatusEnum =
  (typeof AssignmentStatusEnum)[keyof typeof AssignmentStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssignmentStatusEnum = {
  Created: 100,
  OnHold: 105,
  Planned: 110,
  AssignedToCarTransportTruck: 190,
  Assigned: 200,
  Accepted: 300,
  Started: 400,
  LoadedCars: 410,
  Inspected: 450,
  StartedDriving: 460,
  Arrived: 500,
  TestComplete: 600,
  Returning: 700,
  FinishedDriving: 705,
  UnLoadedCars: 710,
  Complete: 800,
  Approved: 900,
  CanceledNotFinished: 950,
  Canceled: 1000,
  AbortedNotFinished: 1050,
  Aborted: 1100,
  Discarded: 1200,
} as const;
